import { SortDirection } from '../../const';

export const invertSortDirection = (direction: SortDirection) =>
    direction === SortDirection.ASC
        ? SortDirection.DESC
        : SortDirection.ASC;
